import React from "react";

const SectionHeader = (props) => {
  return (
    <div className="section-header">
      <h2 className="text-3xl font-bold">{props.title}</h2>
      <p className="subtitle">
        {props.subtitle} <span>{props.greenText}</span> {props.subtitleFinish}
      </p>
    </div>
  );
};

export default SectionHeader;
